import { Box } from '@chakra-ui/react';

import InfoStockDetail from 'View/host-stock-promo/component/info-stock-detail';
import ListStockDetail from 'View/host-stock-promo/component/list-stock-detail';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import styles from './styles.module.css';

const HostStockDetail = () => {
  const { state } = useHostStockPromoState();

  return (
    <Box className={styles['stock-detail__container']} data-testid="stock-detail">
      <InfoStockDetail data={state?.selectedDetailStock} />
      <ListStockDetail data={state?.selectedDetailStock} />
    </Box>
  );
};

export default HostStockDetail;
